/* Challenges gallery (sections/challenges-gallery.liquid): filters, counts, load more on scroll. */
(function () {
  var root = document.querySelector('[data-cxg]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  /* Biggest builds first: sorted by number of pieces (data-pieces), ties keep the blog order. */
  var cards = Array.prototype.slice.call(root.querySelectorAll('.cxg__card'))
    .map(function (c, i) { return { c: c, i: i, p: parseInt(c.dataset.pieces, 10) || 0 }; })
    .sort(function (a, b) { return b.p - a.p || a.i - b.i; })
    .map(function (o) { return o.c; });
  var grid = root.querySelector('[data-cxg-grid]');
  var blogOrder = cards.slice();
  /* With a pack picked: that pack's own challenges (Main pack) first, then this heading, then the others its pieces can build. */
  var otherHead = document.createElement('h2');
  otherHead.className = 'cxg__other';
  otherHead.textContent = (grid && grid.dataset.otherLabel) || 'Other challenges you can complete with the pieces in this pack';
  otherHead.hidden = true;
  var lastOrder = null;
  function isMain(c, key) { return (c.dataset.main || '').indexOf('|' + key + '|') !== -1; }
  var pills = Array.prototype.slice.call(root.querySelectorAll('.cxg__pill'));
  var levels = Array.prototype.slice.call(root.querySelectorAll('.cxg__level'));
  var toggle = root.querySelector('.cxg__toggle');
  var panel = root.querySelector('.cxg__packs');
  var summary = root.querySelector('[data-cxg-summary]');
  var clearBtn = root.querySelector('[data-cxg-clear]');
  var sentinel = root.querySelector('[data-cxg-sentinel]');
  var empty = root.querySelector('[data-cxg-empty]');
  var mq = window.matchMedia('(max-width: 699px)');
  var deskBatch = parseInt(root.dataset.desktopBatch, 10) || 9;
  var mobBatch = parseInt(root.dataset.mobileBatch, 10) || 10;

  var params = new URLSearchParams(location.search);
  var state = { pack: params.get('pack') || '', level: params.get('level') || '', q: params.get('q') || '', limit: 0 };
  var search = root.querySelector('[data-cxg-search]');
  var emptyText = root.querySelector('[data-cxg-empty-text]');
  var searchAll = root.querySelector('[data-cxg-search-all]');
  function norm(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  cards.forEach(function (c) { var n = c.querySelector('.cxg__name'); c.dataset.q = ' ' + norm(n ? n.textContent : '') + ' '; });
  /* every word typed must appear somewhere in the name: "rex" finds T-Rex, "fish" finds Rainbow Fish and Angelfish */
  function hasQ(c) { var w = norm(state.q); if (!w) return true; return w.split(' ').every(function (x) { return c.dataset.q.indexOf(x) !== -1; }); }

  // Packs a signed-in customer has bought ("|key|key|"), from their orders.
  var owned = (root.dataset.owned || '').split('|').filter(Boolean);
  function hasPack(card, key) {
    if (!key) return true;
    if (key === '__mine') return owned.some(function (k) { return card.dataset.packs.indexOf('|' + k + '|') !== -1; });
    return card.dataset.packs.indexOf('|' + key + '|') !== -1;
  }
  function hasLevel(card, lv) { return !lv || card.dataset.level === lv; }
  /* a search always looks through the whole catalogue: pack and difficulty filters are set aside while there is a query */
  function searching() { return !!norm(state.q); }
  function passes(c, pack, lv) { return searching() ? hasQ(c) : hasPack(c, pack) && hasLevel(c, lv); }
  function count(fn) { var n = 0; for (var i = 0; i < cards.length; i++) if (fn(cards[i])) n++; return n; }
  function batch() { return mq.matches ? mobBatch : deskBatch; }

  // Packs with no challenges at all are hidden; a pack in the address that doesn't exist is ignored.
  pills.forEach(function (p) {
    var key = p.dataset.pack;
    if (key && count(function (c) { return hasPack(c, key); }) === 0) p.remove();
  });
  pills = Array.prototype.slice.call(root.querySelectorAll('.cxg__pill'));
  root.querySelectorAll('.cxg__row').forEach(function (row) { if (!row.querySelector('.cxg__pill')) row.remove(); });
  if (state.pack && !root.querySelector('.cxg__pill[data-pack="' + state.pack + '"]')) state.pack = '';
  // Signed-in customers who own packs start on their packs (unless the link already picks one).
  if (!params.get('pack') && owned.length && root.querySelector('.cxg__pill[data-pack="__mine"]')) state.pack = '__mine';
  owned.forEach(function (k) {
    var p = root.querySelector('.cxg__pill[data-pack="' + k + '"]');
    if (p) {
      p.classList.add('is-owned');
      var tag = document.createElement('span');
      tag.className = 'cxg__yours';
      tag.setAttribute('title', 'You have this pack');
      tag.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6.2 6.6.7-5 4.5 1.4 6.6L12 17.2l-5.9 3.3 1.4-6.6-5-4.5 6.6-.7z" fill="currentColor"/></svg><i class="cxg__sr">(you have this pack)</i>';
      p.insertBefore(tag, p.querySelector('[data-cxg-count]'));
    }
    var bar = root.querySelector('[data-cxg-packbar="' + k + '"]');
    if (bar) bar.classList.add('is-owned');
  });
  if (['', 'easy', 'medium', 'hard'].indexOf(state.level) === -1) state.level = '';

  function render() {
    var matches = cards.filter(function (c) { return passes(c, state.pack, state.level); });
    var limit = state.limit || batch();
    var split = !!state.pack && state.pack !== '__mine' && !searching();
    var mine = [], rest = [];
    if (split) {
      matches.forEach(function (c) { (isMain(c, state.pack) ? mine : rest).push(c); });
      matches = mine.concat(rest);
    }
    var orderKey = split ? state.pack + '/' + state.level : '';
    if (orderKey !== lastOrder) {
      lastOrder = orderKey;
      if (otherHead.parentNode) otherHead.parentNode.removeChild(otherHead);
      (split ? matches.concat(blogOrder.filter(function (c) { return matches.indexOf(c) === -1; })) : blogOrder)
        .forEach(function (c) { grid.appendChild(c); });
    }
    if (split && mine.length && rest.length) {
      if (otherHead.nextSibling !== rest[0]) grid.insertBefore(otherHead, rest[0]);
      otherHead.hidden = mine.length >= limit;
    } else if (otherHead.parentNode) {
      otherHead.parentNode.removeChild(otherHead);
    }
    cards.forEach(function (c) { c.hidden = true; });
    matches.forEach(function (c, i) { c.hidden = i >= limit; });
    /* a challenge opened from a pack filter steps through that pack's challenges (challenge-page.js reads ?pack=) */
    cards.forEach(function (c) {
      if (!c.dataset.href) c.dataset.href = c.getAttribute('href');
      c.setAttribute('href', state.pack && state.pack !== '__mine' ? c.dataset.href + '?pack=' + encodeURIComponent(state.pack) : c.dataset.href);
    });

    pills.forEach(function (p) {
      var on = !searching() && p.dataset.pack === state.pack;
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
      var n = count(function (c) { return hasPack(c, p.dataset.pack) && hasLevel(c, state.level); });
      p.querySelector('[data-cxg-count]').textContent = n;
      p.classList.toggle('is-empty', n === 0 && !on);
    });
    levels.forEach(function (b) {
      var on = searching() ? !b.dataset.level : b.dataset.level === state.level;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.querySelector('[data-cxg-count]').textContent = count(function (c) { return hasPack(c, state.pack) && hasLevel(c, b.dataset.level); });
    });

    var active = root.querySelector('.cxg__pill[data-pack="' + state.pack + '"]');
    var packName = state.pack && active && !searching() ? active.dataset.name : '';
    root.querySelector('[data-cxg-current]').textContent = packName || 'All packs';
    var curDot = root.querySelector('[data-cxg-current-dot]');
    var activeDot = packName ? active.querySelector('.cxg__dot') : null;
    curDot.hidden = !activeDot;
    if (activeDot) curDot.style.background = activeDot.style.background;
    root.querySelector('[data-cxg-current-count]').textContent = count(function (c) { return hasPack(c, state.pack) && hasLevel(c, state.level); });

    var n = matches.length;
    root.querySelectorAll('[data-cxg-packbar]').forEach(function (b) {
      var on = !!state.pack && !searching() && b.getAttribute('data-cxg-packbar') === state.pack;
      b.hidden = !on;
      if (on) {
        var all = count(function (c) { return hasPack(c, state.pack); });
        b.querySelector('[data-cxg-packbar-meta]').textContent = all + (all === 1 ? ' challenge' : ' challenges') + (state.level ? ' · showing ' + n + ' ' + state.level : '');
      }
    });
    var lvText = state.level && !searching() ? state.level + ' ' : '';
    var words = n + ' ' + lvText + (n === 1 ? 'challenge' : 'challenges') + (state.q ? ' matching “' + state.q.trim() + '”' : '');
    summary.textContent = state.pack === '__mine' && !searching() ? words + ' for the packs you own' : packName ? (mq.matches ? words + ' · ' + packName.replace(/ Pack$/, '') : words + ' you can build with ' + (/ Pack$/.test(packName) ? 'the ' : '') + packName) : words;
    clearBtn.hidden = !state.pack && !state.level && !state.q;
    empty.hidden = n !== 0;
    if (n === 0) {
      emptyText.textContent = searching() ? 'No challenges called “' + state.q.trim() + '”. Try another name.' : 'No challenges match these filters yet. Try another pack or difficulty.';
      searchAll.hidden = true;
    }
    state.more = n > limit;
  }

  function setUrl() {
    var q = new URLSearchParams(location.search);
    state.pack && state.pack !== '__mine' ? q.set('pack', state.pack) : q.delete('pack');
    state.level ? q.set('level', state.level) : q.delete('level');
    state.q.trim() ? q.set('q', state.q.trim()) : q.delete('q');
    var s = q.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
  }

  pills.forEach(function (p) {
    p.addEventListener('click', function () {
      var key = p.dataset.pack;
      if (searching()) { state.q = ''; search.value = ''; state.pack = key; } else state.pack = state.pack === key ? '' : key;
      state.limit = 0;
      if (mq.matches) { panel.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
      setUrl(); render();
    });
  });
  levels.forEach(function (b) {
    b.addEventListener('click', function () { state.q = ''; search.value = ''; state.level = b.dataset.level; state.limit = 0; setUrl(); render(); });
  });
  toggle.addEventListener('click', function () {
    var open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  clearBtn.addEventListener('click', function () { state.pack = ''; state.level = ''; state.q = ''; search.value = ''; state.limit = 0; setUrl(); render(); });
  search.value = state.q;
  search.addEventListener('input', function () { state.q = search.value; state.limit = 0; setUrl(); render(); });
  search.addEventListener('keydown', function (e) { if (e.key === 'Escape') { search.value = ''; state.q = ''; setUrl(); render(); } });
  searchAll.addEventListener('click', function () { state.pack = ''; state.level = ''; state.limit = 0; setUrl(); render(); });

  // Load the next batch when the end of the list comes into view.
  var ticking = false;
  function maybeLoad() {
    ticking = false;
    if (!state.more) return;
    if (sentinel.getBoundingClientRect().top < window.innerHeight + 600) {
      state.limit = (state.limit || batch()) + batch();
      render();
      setTimeout(maybeLoad, 50);
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; setTimeout(maybeLoad, 100); }
  }, { passive: true });
  (mq.addEventListener ? mq.addEventListener('change', function () { state.limit = 0; render(); }) : mq.addListener(function () { state.limit = 0; render(); }));

  render();
})();
